import PropTypes from 'prop-types'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import useDidUpdateEffect from '../../../../common/hooks/useDidUpdateEffect'
import { Element } from '../../../../common/html/element'
import { SelectCustom } from '../../../../common/selectCustom'
import { debounce } from '../../../../helpers/common'
import { Input } from '../../../common/html/input'
import { InputSearchDropdown } from '../../../common/html/input/InputSearchDropdown'
import { PORTFOLIO_VALUES, SELECT_PORTFOLIO } from '../constant'
import style from '../index.module.scss'
import {
  changeIdCompanySearch,
  changePageSizeTable,
  getLoadingSavedPortfolio,
  selectDataPageTableSavedPortfolio,
  selectDataSearchCompany,
  selectFilter,
} from '../store/slice/slice'
import {
  changeNameCompany,
  changeTypePortfolio,
  selectNameCompanySearch,
} from '../store/slice/sliceComponent'
import {
  getSavedPortfolioByOrg,
  getSearchCompany,
  getSearchPortfolio,
} from '../store/thunk'
import classes from './search.module.scss'

export const Search = ({ portfolioSelect }) => {
  const dispatch = useDispatch()

  const dataFilter = useSelector(selectFilter)
  const dataSearchCompany = useSelector(selectDataSearchCompany)
  const isLoadingSearch = useSelector(getLoadingSavedPortfolio('searchCompany'))
  const nameCompany = useSelector(selectNameCompanySearch)
  const { page, pageSize } = useSelector(selectDataPageTableSavedPortfolio)

  const handlePortfolioSelect = (item) => {
    dispatch(changeTypePortfolio(item))
  }

  const handleChoose = (value) => {
    dispatch(
      getSavedPortfolioByOrg({
        Page: 1,
        PageSize: 20,
        OrganizationId: value?.organizationId,
        Sort: dataFilter?.sortBy,
        SortDirection: dataFilter?.sortDirection,
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(
          changePageSizeTable({
            page: 1,
          }),
        )
        dispatch(changeIdCompanySearch(value?.organizationId))
        dispatch(changeNameCompany(value?.organizationName))
      })
      .catch(() => {})
  }

  const onChange = (value) => {
    dispatch(changeNameCompany(value))
  }

  const handleChangeKeyword = useCallback(
    debounce((keyword, portfolioSelect) => {
      if (portfolioSelect.value === PORTFOLIO_VALUES.COMPANY) {
        dispatch(
          getSearchCompany({
            term: keyword,
            page: 1,
            pageSize: 50,
          }),
        )
          .unwrap()
          .then(() => {
            if (keyword.trim() === '') {
              dispatch(
                getSearchPortfolio({
                  InputSearch: keyword,
                  Page: page,
                  PageSize: pageSize,
                }),
              )
              dispatch(changeIdCompanySearch(undefined))
            } else {
              dispatch(
                changePageSizeTable({
                  page: page,
                  pageSize: pageSize,
                }),
              )
            }
          })
          .catch(() => {})
      }
      if (portfolioSelect.value === PORTFOLIO_VALUES.PORTFOLIO) {
        dispatch(
          getSearchPortfolio({
            InputSearch: keyword,
            Page: 1,
            PageSize: 20,
          }),
        )
          .unwrap()
          .then(() => {})
          .catch(() => {})
      }
    }, 400),
    [],
  )

  useDidUpdateEffect(() => {
    handleChangeKeyword(nameCompany, portfolioSelect)
  }, [nameCompany, portfolioSelect])

  const renderElement = () => {
    return (
      <Input
        containerStyle={{
          flex: 1,
          minWidth: 470,
          height: '28px',
        }}
        placeHolder={
          portfolioSelect.value === PORTFOLIO_VALUES.PORTFOLIO
            ? 'library.savePortfolio.SEARCH_PORTFOLIO'
            : 'library.savePortfolio.SEARCH_COMPANIES'
        }
        type="text"
        isSearch
        onChange={onChange}
        id="inputSearchCompanyLibrary"
        valueAfterOnChange={nameCompany}
        defaultValue={nameCompany}
      />
    )
  }

  const renderDropdown = ({ hideDropdown }) => {
    return (
      <div className={classes.dropdown}>
        {dataSearchCompany?.map((item) => (
          <DropdownItem
            key={item?.organizationId}
            item={item}
            hideDropdown={hideDropdown}
            handleChoose={handleChoose}
          />
        ))}
      </div>
    )
  }

  const renderNodata = () => {
    return (
      <Element style={{ fontStyle: 'italic', padding: 12 }}>
        <Translate value="library.main.NODATA_SEARCH_COMPANY" />
      </Element>
    )
  }

  useEffect(() => {
    dispatch(changeNameCompany(''))
  }, [portfolioSelect])

  return (
    <div className={['dFlex', style.search].join(' ')}>
      <Element className={['dFlex', style.contentLeft].join(' ')}>
        <SelectCustom
          activeItem={portfolioSelect}
          data={SELECT_PORTFOLIO}
          style={{
            backgroundColor: '#e5e5e8',
            marginRight: 8,
            fontWeight: 600,
          }}
          chooseItem={handlePortfolioSelect}
          isI18n
        />
        {portfolioSelect.value === PORTFOLIO_VALUES.PORTFOLIO && (
          <>{renderElement()}</>
        )}
        {portfolioSelect.value === PORTFOLIO_VALUES.COMPANY && (
          <InputSearchDropdown
            renderElement={renderElement}
            renderDropdown={renderDropdown}
            dropdownItemHeight={50}
            maxDropdownItem={10}
            data={dataSearchCompany}
            style={{ minWidth: 470, flex: 1 }}
            isLoading={isLoadingSearch}
            renderNodata={renderNodata}
          />
        )}
      </Element>
    </div>
  )
}

export const DropdownItem = ({
  item,
  hideDropdown,
  handleChoose,
  noHiddenWhenClick,
}) => {
  const [bgColor, setBgColor] = useState('transparent')

  const onMouseEnter = () => {
    setBgColor('#F3F3F3')
  }

  const onMouseLeave = () => {
    setBgColor('transparent')
  }

  return (
    <Element
      onClick={() => {
        handleChoose(item)
        !noHiddenWhenClick && hideDropdown(false)
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{ backgroundColor: bgColor }}
      className={classes.dropdownItem}
    >
      <div className={classes.item}>
        <Element
          elementName="span"
          style={{
            fontSize: 10,
            fontWeight: 600,
          }}
        >
          <Translate value="library.detailsPortfolios.TAX_CODE" />
        </Element>
        <Element
          elementName="p"
          style={{
            fontSize: 10,
            fontWeight: 400,
          }}
        >
          {item?.taxCode}
        </Element>{' '}
      </div>
      <div>
        <Element
          elementName="p"
          style={{
            fontSize: 10,
            color: '#191D25',
            textTransform: 'uppercase',
          }}
        >
          {item?.organizationName}
        </Element>
      </div>
    </Element>
  )
}

DropdownItem.propTypes = {
  isDetails: PropTypes.bool,
}
DropdownItem.defaultProps = {
  isDetails: false,
}
